import { Button } from "@mantine/core";
import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ConfirmationButton from "src/components/shared/ConfirmationButton/ConfirmationButton";
import { usePostApi } from "src/hooks";
import { getYachtId } from "src/utils";

interface Props {
  status: number;
  isAudit?: boolean;
}
const CommentsButtons = ({ status, isAudit }: Props) => {
  const { aid } = useParams();
  const navigate = useNavigate();
  const { post, isLoading } = usePostApi();

  const handleRequestReviewComments = useCallback(async () => {
    await post({
      request: "request-review-comments",
      body: { params: { aid, yachtid: getYachtId() } },
    });
  }, [aid, post]);

  const handleGetRequestedComments = useCallback(async () => {
    navigate(
      `/summary/${
        isAudit ? "audits/audit" : "reviews/review"
      }/${aid}/requested-comments`,
    );
  }, [aid, isAudit, navigate]);

  return status === 2 ? (
    <Button variant="outline" onClick={handleGetRequestedComments}>
      View Review Comments
    </Button>
  ) : (
    <ConfirmationButton
      modalText="Are you sure you want to request review comments for these entry?"
      onConfirm={handleRequestReviewComments}
      loading={isLoading}>
      Request Review Comments
    </ConfirmationButton>
  );
};
export default CommentsButtons;
